import React from 'react';
import Rodal from 'rodal';
import { History } from 'history';
import TransferApplicationDocumentReviewPage from '../pages/TransferApplicationDocumentReviewPage';

const REVIEW_PATH = '/transferencias/aplicacoes/:token/analise-documental';

type Props = {
  token: string,
  history: History,
  onClose: () => void,
};

// Abre a Análise Secretaria sem sair da tela de convocados: a própria página é
// renderizada dentro do modal, com um `match` sintético no lugar do da rota. Ela é
// autossuficiente (busca a inscrição pelo token), então nada precisa ser duplicado.
const DocumentReviewModal = ({ token, history, onClose }: Props) => {
  const match = {
    params: { token },
    isExact: true,
    path: REVIEW_PATH,
    url: `/transferencias/aplicacoes/${token}/analise-documental`,
  };

  return (
    <Rodal
      closeOnEsc
      visible
      width={Math.min(1180, Math.round(window.innerWidth * 0.94))}
      height={Math.round(window.innerHeight * 0.9)}
      onClose={onClose}
      className="tcp-review-modal"
      customStyles={{ padding: 0, borderRadius: 18 }}
    >
      <div className="tcp-review-modal-body">
        <TransferApplicationDocumentReviewPage history={history} match={match} />
      </div>
    </Rodal>
  );
};

export default DocumentReviewModal;
